<template>
  <div>
    <Nav></Nav>

    <mdb-container class="home-section hello">
      <mdb-row class="mb-4">
        <mdb-col md="12">
          <img
            src="img/charlotte-intro.jpg"
            class="rounded-circle img-fluid float-left mr-3"
            width="85px"
          />
          <mdb-card class="my-2">
            <mdb-card-body :key="'hiiam'+refresher">
              Hi {{userNickOrEmailTheWordAfterHi}}. I am Charlotte. Welcome to Exsellance Family. Let me give you a
              <span
                class="link"
                @click="showWelcomeVideo = true"
              >brief introduction to our Platform.</span>
              <!--<mdb-btn
              @click="showWelcomeVideo = true"
              color="primary"
              class="btn-ssm ml-2"
              rounded
            > Watch now</mdb-btn>
              <span @click="showWelcomeVideo = true">Watch now</span>-->
            </mdb-card-body>
          </mdb-card>
        </mdb-col>
      </mdb-row>
    </mdb-container>

    <mdb-container class="home-section">
      <mdb-row>
        <mdb-col md="12" class="d-flex">
          <router-link
            to="/assessment-welcome"
            class="w-100"
            v-if="hasUserFilledTheAssessmen() === 'false'"
          >
            <mdb-card class="tile-skills top-bar-purple">
              <mdb-card-body class>
                <h2 class>10 Critical Sales Skills for Success</h2>
                <mdb-card-text class="challenge to-left">
                  Take a short quiz (5 minutes)
                  <br />Identify any sales skills gaps
                  <br />Get your personalised sales video recommendation
                  <br />Close any gaps
                </mdb-card-text>
              </mdb-card-body>
              <mdb-card-footer small muted class="d-flex align-items-start text-grey">
                <router-link to="/assessment-welcome">
                  <mdb-btn color="primary" class="ml-0" rounded>Start Quiz</mdb-btn>
                </router-link>
              </mdb-card-footer>
            </mdb-card>
          </router-link>

          <router-link to="/skills" class="w-100" v-if="hasUserFilledTheAssessmen() === 'true'">
            <mdb-card class="tile-skills top-bar-purple">
              <mdb-card-body class>
                <h2 class>10 Critical Sales Skills for Success</h2>
                <mdb-card-text
                  class="challenge to-left"
                >Your personalised sales video recommendations</mdb-card-text>
              </mdb-card-body>
              <mdb-card-footer small muted class="d-flex align-items-start text-grey">
                <router-link to="/skills">
                  <mdb-btn color="primary" class="ml-0" rounded>Start Learning</mdb-btn>
                </router-link>
              </mdb-card-footer>
            </mdb-card>
          </router-link>
        </mdb-col>
      </mdb-row>
    </mdb-container>

    <!-- Content docks -->

    <mdb-container class="home-section tile-courses">
      <mdb-row class="mb-3">
        <mdb-col class="text-left">
          <h2>Sales Masterclass</h2>
        </mdb-col>
      </mdb-row>
      <mdb-row>
        <mdb-col md="6" xl="4" class="d-flex mb-4">
          <router-link to="/course/How-to-find-clients" class="bg-find">
            <!-- first card -->
            <mdb-card class="box-gradient-white-2 top-bar-green">
              <mdb-badge pill color="bg-green" class="cat-badge">
                <mdb-icon icon="video" />&nbsp;COURSE
              </mdb-badge>
              <mdb-card-body class="d-flex flex-column">
                <mdb-card-title class="mt-5">How to find clients</mdb-card-title>
                <mdb-card-text
                  class="mb-2"
                >Learn how to build your ideal clients, where to find them and how to engage with them</mdb-card-text>
              </mdb-card-body>
              <mdb-card-footer small muted>
                <span
                  class="lesson-count"
                >{{mthGetNumberOfLessonsByCoursename('How to find clients')}} lessons</span>
                <mdb-progress :height="5" :value="mthGetProgress('How to find clients')" class />
                {{mthGetProgress("How to find clients")}}%
                <span class="learn">
                  {{mthWordStartOrContinueByProgress('How to find clients')}} Learning
                  <mdb-icon icon="angle-double-right" />
                </span>
              </mdb-card-footer>
            </mdb-card>
          </router-link>
        </mdb-col>
        <mdb-col md="6" xl="4" class="d-flex mb-4">
          <router-link
            to="/course/How-to-sell-and-win"
            style="background-image: url('img/new-01.jpg'); 	background-position: center;
      background-repeat: no-repeat;
      background-size: cover; border-radius: 5px;"
          >
            <!-- second card -->
            <mdb-card class="box-gradient-white-2 top-bar-green">
              <mdb-badge pill color="bg-green" class="cat-badge">
                <mdb-icon icon="video" />&nbsp;COURSE
              </mdb-badge>
              <mdb-card-body class="d-flex flex-column">
                <mdb-card-title class="mt-5">How to sell & win</mdb-card-title>
                <mdb-card-text
                  class="mb-2"
                >Master the critical sales steps of planning, engaging with clients, crafting compelling sales proposals, negotiating, closing and follow up</mdb-card-text>
              </mdb-card-body>
              <mdb-card-footer small muted>
                <span
                  class="lesson-count"
                >{{mthGetNumberOfLessonsByCoursename('How to sell and win')}} lessons</span>
                <mdb-progress :height="5" :value="mthGetProgress('How to sell and win')" class />
                {{mthGetProgress("How to sell and win")}}%
                <span class="learn">
                  {{mthWordStartOrContinueByProgress('How to sell and win')}} Learning
                  <mdb-icon icon="angle-double-right" />
                </span>
              </mdb-card-footer>
            </mdb-card>
          </router-link>
        </mdb-col>
        <mdb-col md="6" xl="4" class="d-flex mb-4">
          <router-link
            to="/course/How-to-sell-more"
            style="background-image: url('img/more-01.jpg'); 	background-position: center;
      background-repeat: no-repeat;
      background-size: cover; border-radius: 5px;"
          >
            <!-- third card -->
            <mdb-card class="box-gradient-white-2 top-bar-green">
              <mdb-badge pill color="bg-green" class="cat-badge">
                <mdb-icon icon="video" />&nbsp;COURSE
              </mdb-badge>
              <mdb-card-body class="d-flex flex-column">
                <mdb-card-title class="mt-5">How to sell more</mdb-card-title>
                <mdb-card-text
                  class="mb-2"
                >Practical guidance to help to stay ahead of the competition and build deeper relationships to sell more with confidence</mdb-card-text>
              </mdb-card-body>
              <mdb-card-footer small muted>
                <span
                  class="lesson-count"
                >{{mthGetNumberOfLessonsByCoursename('How to sell more')}} lessons</span>
                <mdb-progress :height="5" :value="mthGetProgress('How to sell more')" class />
                {{mthGetProgress("How to sell more")}}%
                <span class="learn">
                  {{mthWordStartOrContinueByProgress('How to sell more')}} Learning
                  <mdb-icon icon="angle-double-right" />
                </span>
              </mdb-card-footer>
            </mdb-card>
          </router-link>
        </mdb-col>
      </mdb-row>
    </mdb-container>

    <mdb-container class="home-section">
      <mdb-row>
        <mdb-col md="12" class="d-flex">
          <router-link to="/community" class="w-100">
            <mdb-card class="tile-community d-flex top-bar-blue">
              <mdb-card-body class>
                <h2 class>
                  Your Community
                  <mdb-icon
                    far
                    icon="thumbs-up"
                    class="text-blue"
                    style="font-size: 0.7em; margin-bottom: 3px; position: absolute; margin-top: 8px; margin-left: 10px;"
                  />
                </h2>
                <mdb-card-text class="to-left">
                  <!--<mdb-icon icon="question-circle" class="text-purple" /> Post questions <mdb-icon icon="exclamation-circle" class="text-purple ml-3" /> Find answers <mdb-icon icon="users" class="text-purple ml-3" /> Help solve challenges together  <mdb-icon icon="user-tie" class="text-purple ml-3" /> Share success stories and more-->
                  Post questions, find answers, help solve challenges together, share success stories and more
                </mdb-card-text>
              </mdb-card-body>
              <mdb-card-footer small muted class="d-flex align-items-center text-grey">
                <span style="font-size: 1.2em;">
                  Join the conversation
                  <mdb-icon icon="angle-double-right" />
                </span>
              </mdb-card-footer>
            </mdb-card>
          </router-link>
        </mdb-col>
      </mdb-row>
    </mdb-container>

    <mdb-container class="home-section">
      <mdb-row class="mb-5">
        <mdb-col md="12" class="d-flex">
          <router-link to="/podcasts" class="w-100">
            <mdb-card class="tile-sales-talk card-image d-flex top-bar-yellow">
              <mdb-card-body class>
                <h2 class>
                  Sales Podcasts
                  <mdb-icon icon="podcast" class="title-icon text-yellow" />
                </h2>
                <mdb-card-text
                  class="to-left"
                >Keep up-to-date with the latest sales thinking with the industry leaders and disruptors</mdb-card-text>
              </mdb-card-body>
              <mdb-card-footer small muted class="d-flex align-items-center text-grey">
                <span style="font-size: 1.2em;">
                  Listen now
                  <mdb-icon icon="angle-double-right" />
                </span>
              </mdb-card-footer>
            </mdb-card>
          </router-link>
        </mdb-col>
      </mdb-row>
    </mdb-container>

    <mdb-container class="home-section">
      <mdb-row class="mt-5 pt-3">
        <mdb-col class="text-left">
          <h3>Our Partners</h3>
        </mdb-col>
      </mdb-row>
      <mdb-row class="mb-4">
        <mdb-col md="12" class="d-flex">
          <a href="https://www.enterprisenation.com/get-connected/sales-experts/" class="w-100">
            <mdb-card class="partners card-image d-flex top-bar-purple">
              <mdb-card-body class>
                <h2 class>Business advisers for SME</h2>
                <mdb-card-text class="to-right"></mdb-card-text>
                <mdb-row class="justify-content-end">
                  <mdb-col md="6" class="text-center">
                    <img src="img/enterprise-nation-logo.jpg" class="partner-logo img-fluid" />
                  </mdb-col>
                </mdb-row>
              </mdb-card-body>
              <mdb-card-footer small muted class="d-flex align-items-center text-grey">
                <span style="font-size: 1.2em;">
                  Visit partner's website
                  <mdb-icon icon="angle-double-right" />
                </span>
              </mdb-card-footer>
            </mdb-card>
          </a>
        </mdb-col>
      </mdb-row>
    </mdb-container>

    <!--
  <mdb-container class="content courses my-4 mb-5">
    <mdb-row class="mb-4">
      <mdb-col class="text-left">
        <h2 class="h2-section">Exclusive Interviews Series</h2>
      </mdb-col>
    </mdb-row>
    <mdb-row class="mb-4">
      <mdb-col md="4" class="d-flex">
        <router-link to="/course/Listening" class="w-100" style="background-image: url('https://appen.nazwa.pl/hardlight/projekty/ex2/branson.jpg'); 	background-position: center;
      background-repeat: no-repeat;
      background-size: cover; border-radius: 5px;">
          <mdb-card class="box-gradient-white-3" style="flex: 1;">
            <mdb-badge pill color="bg-yellow" class="cat-badge">EPISODE 003</mdb-badge>
            <mdb-card-body class="d-flex flex-column" style="justify-content: flex-end">
              <mdb-card-title class="mt-5 " style="font-size: 2.2rem; font-weight: 900;">Richard Branson</mdb-card-title>
              <mdb-card-text class="mb-2">CEO of Virgin</mdb-card-text>
            </mdb-card-body>
            <mdb-card-footer small muted>
              <span class="lesson-count">
                23 min
              </span>
              <span class="learn">
                Listen now
              </span>
              </mdb-card-footer>
          </mdb-card>
        </router-link>
      </mdb-col>
      <mdb-col md="4" class="d-flex">
        <router-link to="/course/Listening" class="w-100" style="background-image: url('https://appen.nazwa.pl/hardlight/projekty/ex2/ben.jpg'); 	background-position: center;
      background-repeat: no-repeat;
      background-size: cover; border-radius: 5px;">
          <mdb-card class="box-gradient-white-3">
            <mdb-badge pill color="bg-yellow" class="cat-badge">EPISODE 004</mdb-badge>
            <mdb-card-body class="d-flex flex-column" style="justify-content: flex-end">
              <mdb-card-title class="mt-5 " style="font-size: 2.2rem; font-weight: 900;">Ben Dowd</mdb-card-title>
              <mdb-card-text class="mb-2">Ben led O2’s ground-breaking transformation</mdb-card-text>
            </mdb-card-body>
            <mdb-card-footer small muted>
              <span class="lesson-count">
                19 min
              </span>
              <span class="learn">
                Listen now
              </span>
            </mdb-card-footer>
          </mdb-card>
        </router-link>
      </mdb-col>
      <mdb-col md="4" class="d-flex ">
        <router-link to="/course/Listening" class="w-100" style="background-image: url('https://appen.nazwa.pl/hardlight/projekty/ex2/owen-brady.jpg'); 	background-position: bottom center;
      background-repeat: no-repeat;
      background-size: cover; border-radius: 5px;">
          <mdb-card class="box-gradient-white-3">
            <mdb-badge pill color="bg-yellow" class="cat-badge">EPISODE 005</mdb-badge>
            <mdb-card-body class="d-flex flex-column" style="justify-content: flex-end">
              <mdb-card-title class="mt-5 " style="font-size: 2.2rem; font-weight: 900;">Owen Brady</mdb-card-title>
              <mdb-card-text class="mb-2">Nuffield Hospitals, Nations Health Care, Whipps Cross and latterly at Moorfields Eye Hospital</mdb-card-text>
            </mdb-card-body>
            <mdb-card-footer small muted>
              <span class="lesson-count">
                17 min
              </span>
              <span class="learn">
                Listen now
              </span>
            </mdb-card-footer>
          </mdb-card>
        </router-link>
      </mdb-col>
    </mdb-row>
  </mdb-container>



    <mdb-container class="mt-5 mb-5 py-4 content courses">
      <mdb-row class="mb-4">
        <mdb-col class="text-left">
          <h2 class="h2-section">Exclusive Interviews Series</h2>
        </mdb-col>
      </mdb-row>
      <mdb-row class="mb-4">
        <mdb-col md="4">
          <router-link
            to="/podcasts"
            class="w-100"
            style="background-image: url('https://appen.nazwa.pl/hardlight/projekty/ex2/branson.jpg'); 	background-position: right;
      background-repeat: no-repeat;
      background-size: cover; border-radius: 5px;"
          >
            <mdb-card>
              <mdb-card-body>
                <div class="top-info-text mb-2">EPISODE #004</div>
                <mdb-card-title>Richard Branson</mdb-card-title>
                <mdb-card-text>Sir Richard Charles Nicholas Branson is a British business magnate, investor, author and philanthropist. He founded the Virgin Group in the 1970s, which controls more than 400 companies in various fields. Branson expressed his desire to become an entrepreneur at a young age.</mdb-card-text>
              </mdb-card-body>
              <mdb-card-footer small muted class="date">21.07.2019</mdb-card-footer>
            </mdb-card>
          </router-link>
        </mdb-col>
        <mdb-col md="4">
          <mdb-card>
            <mdb-card-image
              src="https://appen.nazwa.pl/hardlight/projekty/ex2/ben.jpg"
              alt="Card image cap"
            ></mdb-card-image>
            <mdb-card-body>
              <div class="top-info-text mb-2">EPISODE #003</div>
              <mdb-card-title>Ben Dowd</mdb-card-title>
              <mdb-card-text>Ben inspires ambition. For 20 years, Ben was a pioneering leader at O2. Along with a handful of colleagues, Ben led O2’s ground-breaking transformation from being a laggard mobile player to becoming one of the UK’s most iconic brands. He continues to lead the communication industry as CEO of ONECOM and is equally passionate about Exsellance and the British economy.</mdb-card-text>
            </mdb-card-body>
            <mdb-card-footer small muted class="date">21.07.2019</mdb-card-footer>
          </mdb-card>
        </mdb-col>
        <mdb-col md="4">
          <mdb-card>
            <mdb-card-image
              src="https://appen.nazwa.pl/hardlight/projekty/ex2/owen-brady.jpg"
              alt="Card image cap"
            ></mdb-card-image>
            <mdb-card-body>
              <div class="top-info-text mb-2">EPISODE #002</div>
              <mdb-card-title>Owen Brady</mdb-card-title>
              <mdb-card-text>Owen is a senior operational manager and director who has worked at board level within the healthcare industry. He has run large IT and operational departments within public and private sectors over the last 25 years including; Nuffield Hospitals, Nations Health Care, Whipps Cross and latterly at Moorfields Eye Hospital. He has delivered group wide IT transformation and change management programmes delivering innovation and value that are business aligned.</mdb-card-text>
            </mdb-card-body>
            <mdb-card-footer small muted class="date">21.07.2019</mdb-card-footer>
          </mdb-card>
        </mdb-col>
      </mdb-row>
    </mdb-container>
    -->
    <!--
    <mdb-container fluid class="browse-by-cat bg-lightGrey py-2">
      <mdb-container fluid class="bg-lightGrey py-2">
      <mdb-container class="my-4">
        <mdb-row class="mb-4">
          <mdb-col class="text-left">
            <h2 class="h2-section">Browse by category</h2>
          </mdb-col>
        </mdb-row>
        <mdb-row class="mb-4">
          <mdb-col sm="6" xl="4">
            <a href="#" class="a-card tile-video">
              <mdb-card class="home-tile">
                <mdb-card-body>
                  <img src="../assets/icon-videos@2x.png" class="category-icon" />
                  <mdb-card-title class="tile-title">Videos</mdb-card-title>
                  <mdb-card-text>Watch our video course</mdb-card-text>
                </mdb-card-body>
                <mdb-card-footer small muted>47 videos</mdb-card-footer>
              </mdb-card>
            </a>
          </mdb-col>
          <mdb-col sm="6" xl="4">
            <mdb-card class="home-tile">
              <mdb-card-body>
                <img src="../assets/icon-podcasts@2x.png" class="category-icon" />
                <mdb-card-title class="tile-title">Sales Podcasts</mdb-card-title>
                <mdb-card-text>Listen to our monthly sales podcasts</mdb-card-text>
              </mdb-card-body>
              <mdb-card-footer small muted>47 videos</mdb-card-footer>
            </mdb-card>
          </mdb-col>

          <mdb-col sm="6" xl="4">
            <mdb-card class="home-tile">
              <mdb-card-body>
                <img src="../assets/icon-coaching@2x.png" class="category-icon" />
                <mdb-card-title class="tile-title">1-on-1 Sales Coaching</mdb-card-title>
                <mdb-card-text>Learn from our mentors</mdb-card-text>
              </mdb-card-body>
              <mdb-card-footer small muted>47 videos</mdb-card-footer>
            </mdb-card>
          </mdb-col>
          <mdb-col sm="6" xl="4">
            <a href="/community" class="a-card tile-video">
              <mdb-card class="home-tile">
                <mdb-card-body>
                  <img src="../assets/icon-community@2x.png" class="category-icon" />
                  <mdb-card-title class="tile-title">Community</mdb-card-title>
                  <mdb-card-text>Join our community of...</mdb-card-text>
                </mdb-card-body>
                <mdb-card-footer small muted>17 active in last hour</mdb-card-footer>
              </mdb-card>
            </a>
          </mdb-col>
          <mdb-col sm="6" xl="4">
            <mdb-card class="home-tile">
              <mdb-card-body>
                <img src="../assets/icon-knowledge@2x.png" class="category-icon" />
                <mdb-card-title class="tile-title">Articles</mdb-card-title>
                <mdb-card-text>Read articles, case studies and more</mdb-card-text>
              </mdb-card-body>
              <mdb-card-footer small muted>56 articles</mdb-card-footer>
            </mdb-card>
          </mdb-col>
        </mdb-row>
      </mdb-container>
      </mdb-container>
    -->

    <!--
      <mdb-container class="content nowrap my-4" id="index">
        <mdb-row class="mb-4">
          <mdb-col class="text-left">
            <h2 class="h2-section">Recently added</h2>
          </mdb-col>
        </mdb-row>
          <hooper :itemsToShow="3.2" :trimWhitespace="true" :centerMode="false" :pagination="false">

            <slide>
              <mdb-card class="content-tile">
                <mdb-card-image
                  src="https://appen.nazwa.pl/hardlight/projekty/ex2/photo-1.jpg"
                  alt="Card image cap"
                ></mdb-card-image>
                <mdb-badge pill color="purple" class="cat-badge">VIDEO</mdb-badge>
                <mdb-card-body>
                  <mdb-card-title>Clients wants you to reduce the price!</mdb-card-title>
                  <mdb-card-text>If you want to continuously improve your team’s cadence game, you need to understand all the variables in order to optimize them.</mdb-card-text>
                </mdb-card-body>
                <mdb-card-footer small muted>
                  in ATTRACT
                  <span class="date">21.07.2019</span>
                </mdb-card-footer>
              </mdb-card>

            </slide>

            <slide>

              <mdb-card>
                <mdb-card-image
                  src="https://appen.nazwa.pl/hardlight/projekty/ex2/photo-2.jpg"
                  alt="Card image cap"
                ></mdb-card-image>
                <mdb-card-body>
                  <mdb-card-title>Client wants exclusivity</mdb-card-title>
                  <mdb-card-text>If you want to continuously improve your team’s cadence game, you need to understand all the variables in order to optimize them.</mdb-card-text>
                </mdb-card-body>
                <mdb-card-footer small muted>
                  in ATTRACT
                  <span class="date">21.07.2019</span>
                </mdb-card-footer>
              </mdb-card>

            </slide>

            <slide>

              <mdb-card>
                <mdb-card-image
                  src="https://appen.nazwa.pl/hardlight/projekty/ex2/photo-3.jpg"
                  alt="Card image cap"
                ></mdb-card-image>
                <mdb-card-body>
                  <mdb-card-title>Asking for referrals</mdb-card-title>
                  <mdb-card-text>There’s a big difference between having the right tools and leveraging them effectively.</mdb-card-text>
                </mdb-card-body>
                <mdb-card-footer small muted>
                  in ATTRACT
                  <span class="date">21.07.2019</span>
                </mdb-card-footer>
              </mdb-card>

            </slide>

            <slide>

              <mdb-card>
                <mdb-card-image
                  src="https://appen.nazwa.pl/hardlight/projekty/ex2/photo-4.jpg"
                  alt="Card image cap"
                ></mdb-card-image>
                <mdb-card-body>
                  <mdb-card-title>Buyer personality types</mdb-card-title>
                  <mdb-card-text>Some quick example text to build on the card title and make up the bulk of the card's content.</mdb-card-text>
                </mdb-card-body>
                <mdb-card-footer small muted>
                  in ATTRACT
                  <span class="date">21.07.2019</span>
                </mdb-card-footer>
              </mdb-card>

            </slide>
            <hooper-navigation slot="hooper-addons"></hooper-navigation>

          </hooper>

      </mdb-container>

    -->

    <!--
   <mdb-container class="mt-5 mb-5">
      <mdb-row class="mb-4">
        <mdb-col md="12" class="d-flex">
           <router-link to="/course/Listening" class=" w-100" style=" background-image: url('https://appen.nazwa.pl/hardlight/projekty/ex2/jay.jpg'); 	background-position: 400px -150px;
      background-repeat: no-repeat;
      background-size: cover; border-radius: 5px;">
          <mdb-card class="shd home-tile tile-skills card-image d-flex box-gradient-purple-3"  >
            <mdb-card-body class="">
              <h2 class="">Learn from the best in UK</h2>
              <mdb-card-text class="challenge">With our 1-on-1 coaching ..</mdb-card-text>
            </mdb-card-body>
            <mdb-card-footer small muted class="d-flex  align-items-center">
               <router-link to="/assessment-welcome"><mdb-btn color="white" class="" rounded>Book now</mdb-btn></router-link>
            </mdb-card-footer>
          </mdb-card>
           </router-link>
        </mdb-col>
      </mdb-row>
    </mdb-container>
    -->
    <!--
    <mdb-container class="my-4 pt-5">
      <mdb-card class="card-image" style="background-image: url(https://images.pexels.com/photos/1493371/pexels-photo-1493371.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=1260); background-size: cover;">
        <div class="text-white text-center rgba-stylish-strong py-5 px-4">
          <div class="py-5">

            <h2 class="card-title h2 my-4 py-2">1-on-coaching</h2>
            <p class="mb-4 pb-2 px-md-5 mx-md-5">Lorem ipsum dolor sit amet, consectetur adipisicing elit. Pariatur obcaecati vero aliquid libero doloribus ad, unde tempora maiores, ullam, modi qui quidem minima debitis perferendis vitae cumque et quo impedit.</p>
            <mdb-btn tag="a" color="grey" icon="clone">Learn more</mdb-btn> <mdb-btn tag="a" color="primary" icon="clone">Book session now</mdb-btn>
          </div>
        </div>
      </mdb-card>
    </mdb-container>-->
    <mdb-modal
      :show="showWelcomeVideo"
      @close="showWelcomeVideo = false"
      scrollable
      centered
      size="lg"
      class="welcomeVideo"
    >
      <mdb-modal-header></mdb-modal-header>
      <mdb-modal-body>
        <iframe
          src="https://player.vimeo.com/video/370665307"
          key="welcomeVideo"
          ref="welcomeVideo"
          class
          vimeoid="370665307"
          width="100%"
          height="100%"
          frameborder="0"
          allow="autoplay; fullscreen"
          allowfullscreen
        ></iframe>
      </mdb-modal-body>
    </mdb-modal>

    <Footer></Footer>
  </div>
</template>

<script>
import firebase from "firebase/app";
import { store } from "../store";
import Player from "@vimeo/player";
import Nav from "../components/Nav";
import Footer from "../components/Footer";
import {
  mdbContainer,
  mdbRow,
  mdbCol,
  mdbCard,
  mdbCardImage,
  mdbCardBody,
  mdbCardTitle,
  mdbCardText,
  mdbCardFooter,
  mdbBtn,
  mdbBadge,
  mdbProgress,
  mdbIcon,
  mdbModal,
  mdbModalHeader,
  mdbModalTitle,
  mdbModalBody,
  mdbModalFooter
} from "mdbvue";
import {
  Hooper,
  Slide,
  Pagination as HooperPagination,
  Navigation as HooperNavigation
} from "hooper";

export default {
  name: "Home",
  data() {
    return {
      refresher: 0,
      showWelcomeVideo: false,
      courses: [], //used for progress presenting
      progressTrackingOfMine: [], //used for progress presenting
      userNickOrEmailTheWordAfterHi: "Guest",
      userHasFilledTheAssessment: false
    };
  },
  methods: {
    mthWordStartOrContinueByProgress(coursename) {
      var toret = "Start";

      var progress = this.mthGetProgress(coursename);

      if (progress > 1) toret = "Continue";

      return toret;
    },
    mthGetNumberOfLessonsByCoursename(coursename) {
      var toret = 0;

      this.courses.forEach(c => {
        //console.log(c)

        //var counter = 0;

        if (
          c.firedata.name === coursename &&
          c.firedata.newOrEditedCourseDetails
        ) {
          //toret = c.firedata.newOrEditedCourseDetails.length;

          c.firedata.newOrEditedCourseDetails.forEach(element => {
            if (element.type == "video" || element.type == "text") {
              toret++;
            }
          });
        }
      });
      return toret;
    },
    mthGetProgress(coursename) {
      var toret = 0.001;

      var licznik = this.mthGetSumOfVideosProgressesByCoursname(coursename);
      var mianownik = this.mthGetCourseTotalMinutesByName(coursename);

      if (mianownik === 0) return 0;
      if (licznik < 5) return 0;

      //console.log("licznik: " + licznik);
      //console.log("mianownik: " + mianownik);

      toret = (licznik * 100) / mianownik;

      if (toret > 100) return 100;
      if (toret < 0) return 0;

      toret = Math.round(toret);

      if (toret > 98) toret = 100;

      return toret;
    },
    mthGetSumOfVideosProgressesByCoursname(coursename) {
      var toret = 0.00000001;

      this.progressTrackingOfMine.forEach(t => {
        //console.log(t.firedata);

        if (t && t.firedata && t.firedata.courseslug && t.firedata.event) {
          let cname = t.firedata.courseslug
            .replace("-", " ")
            .replace("-", " ")
            .replace("-", " ")
            .replace("-", " ")
            .replace("-", " ")
            .replace("-", " ")
            .replace("-", " ")
            .replace("-", " ")
            .replace("-", " ")
            .replace("-", " ");
          if (cname === coursename && t.firedata.event.seconds)
            toret += t.firedata.event.seconds;
        }
      });

      return toret;
    },
    mthGetCourseTotalMinutesByName(coursename) {
      let totalminutes = 0; //to not divide by 0 ;)
      //console.log('arg is'+coursename)

      this.courses.forEach(c => {
        if (
          c.firedata.name === coursename &&
          c.firedata.newOrEditedCourseDetails
        ) {
          c.firedata.newOrEditedCourseDetails.forEach(d => {
            if (d.type && d.type === "video") {
              if (d && d.data && d.data.data && d.data.data.vimeoduration) {
                totalminutes += d.data.data.vimeoduration;
              }
            }
          });
        }
      });

      return totalminutes;
    },
    mthFillProgressTrackingOfMine() {
      var refProgressTracking = firebase
        .firestore()
        .collection("progressTracking")
        .where("userEmail", "==", this.$store.getters.getUser.email);

      refProgressTracking.onSnapshot(querySnapshot => {
        this.progressTrackingOfMine = [];
        querySnapshot.forEach(doc => {
          this.progressTrackingOfMine.push({
            firedata: doc.data()
          });
        });
        //console.log(this.progressTrackingOfMine);
      });

      return 0.001;
    },
    mthFillCourses() {
      var refcourses = firebase.firestore().collection("courses");

      refcourses.onSnapshot(querySnapshot => {
        this.courses = [];
        querySnapshot.forEach(doc => {
          this.courses.push({
            firedata: doc.data()
          });
        });
        //console.log(this.courses);
      });
    },

    mthGetUserNickOrEmailTheWordAfterHiFromStore() {
      let ret = "Guest";

      /*       console.log(
        "From store: ",
        this.$store.getters.getUserhasfilledhisassessment
      ); */

      if (
        this.$store.getters.getNickname !== null &&
        this.$store.getters.getNickname !== undefined &&
        this.$store.getters.getNickname !== ""
      )
        ret = this.$store.getters.getNickname;

      if (ret === "Guest") {
        if (
          this.$store.getters.getUser !== null &&
          this.$store.getters.getUser.email !== null &&
          this.$store.getters.getUser.email !== undefined &&
          this.$store.getters.getUser.email !== ""
        )
          ret = this.$store.getters.getUser.email.split("@")[0];
      }
      return ret;
    },
    hasUserFilledTheAssessmen() {
      this.userHasFilledTheAssessment = this.$store.getters.getUserhasfilledhisassessment;
      console.log("Wypelnin:", this.userHasFilledTheAssessment);
      return this.$store.getters.getUserhasfilledhisassessment;
    }
  },
  created() {
    this.userNickOrEmailTheWordAfterHi = this.mthGetUserNickOrEmailTheWordAfterHiFromStore();
    this.refresher++;

    this.mthFillCourses();

    this.mthFillProgressTrackingOfMine();
  },
  components: {
    Nav,
    Footer,
    mdbContainer,
    mdbRow,
    mdbCol,
    mdbCard,
    mdbCardImage,
    mdbCardBody,
    mdbCardTitle,
    mdbCardText,
    mdbCardFooter,
    mdbBtn,
    mdbBadge,
    Hooper,
    Slide,
    HooperPagination,
    HooperNavigation,
    mdbProgress,
    mdbIcon,
    mdbModal,
    mdbModalHeader,
    mdbModalTitle,
    mdbModalBody,
    mdbModalFooter
  }
};
</script>

<style>
@import url("https://use.typekit.net/lel8wuy.css");
</style>
